<template>
  <v-app-bar id="app-bar" outlined app flat height="75" style="z-index: 1024;">
    <v-btn v-if="$vuetify.breakpoint.smAndDown" class="mr-3" elevation="0" color="transparent" fab small @click="setDrawer(!drawer)">
      <v-icon>
        mdi-dots-horizontal
      </v-icon>
    </v-btn>

    <v-app-bar-title class="hidden-sm-and-down font-weight-light" v-text="$route.name" />

    <v-spacer />

    <v-btn class="mr-3" elevation="0" color="transparent" fab small @click="() => {dialogActive=!dialogActive; this.$gtag.event('read_log')}">
      <v-icon>
        mdi-update
      </v-icon>
    </v-btn>

    <v-dialog 
      v-model="dialogActive"
      scrollable
    >
      <v-card>
        <v-card-title>
          更新日志
        </v-card-title>
        <v-card-text>
          <p><b>*pinned 有功能建议欢迎到关于页面里的留言板留言</b></p>
          <p>2023/09/27 <a href="/letter">a letter from me</a></p>
          <p>2023/09/27 哈哈好巧啊，刚说了想做这个批站就又收紧了反爬虫，要不然把弹幕功能关了算了，这样你爱说月活多少就是多少了😆</p>
          <p>2023/09/26 更新了个营收数据界面吊你们胃口😁 别急，一两天内上线</p>
          <p>2023/09/11 主播页面加了个一键比较最近两个30天的按钮。</p>
          <p>2023/07/04 由于b站弹幕流会对未登录用户加密，干废了抓独轮车功能，故删除。</p>
          <p>2023/05/27 姑且更新了个overview页面以周/月为单位计算的功能。期末事好多啊😭，没怎么检查，有bug麻烦通过关于中的沟通方式反馈</p>
          <p>2023/05/14 受S1启发，在Overview的深度模式里加了查看发言/打米Top观众的统计。</p>
          <p>2023/05/01 想起来把团队斗虫也加了筛选直播的功能。</p>
          <p>2023/04/27 写了超时空斗虫。临时糊的，欢迎报告bug。下面的折线图暂时缺失。</p>
          <p>2023/04/22 把选择直播的功能也在overview里实现了</p>
          <p>2023/04/22 受豆豆可爱捏的启发，在单人斗虫里增加了选择直播场次的功能。该功能可以选择用于斗虫的具体直播场次，可能的用处包括：对比两个vtb一段时间内纯3d的直播成绩/去除一些由于网络或超管原因数据反常的直播。有时间会在overview页面也实现该功能。</p>
          <p>2023/04/10 直播页面现在可以显示过去10场直播的弹幕、活跃用户和高能均值了。可以为直播效果提供一些参考。</p>
          <p>2023/04/10 增加了overview过滤时长较短直播的功能。没东西写了，感觉好难受，能不能用留言板提点需求啊😭</p>
          <p>2023/04/08 写了个比较简陋的使用手册。</p>
          <p>2023/04/03 斗虫中添加了付费观众的数据</p>
          <p>2023/03/30 应留言板要求，Overview中添加了查看主播开播时间的功能</p>
          <p>2023/03/24 增加了保存斗虫预设功能</p>
          <p>2023/03/23 Overview里添加了平滑曲线的功能，目前就是个取平均数。有更好的算法留言板哦</p>
          <p>2023/03/21 团队斗虫也可以自定义雷达图了。</p>
          <p>2023/03/20 给雷达图加了个引流链接😭 大家喜欢玩的话多引引流😭 过一段时间会删掉的😭</p>
          <p>2023/03/18 斗虫界面搜索时可以输入企业名找到所属的主播了。例如输入a-soul，可以列出其成员</p>
          <p>2023/03/18 单人斗虫支持了自定义雷达图。团队斗虫指标本来就比较少，就没做这个功能，想看的话可以留言板告诉我。</p>
          <p>2023/03/16 在单人斗虫的基础上糊了一个团队斗虫，欢迎报告bug。还有不知道为什么改队名很卡，不过这几天ddl有点多，以后再看😭</p>
          <p>2023/03/12 因为感觉大家不是很喜欢发邮件，所以加了个留言板捏。有建议什么的多说捏</p>
          <p>2023/03/12 直播信息页面支持了自定义统计区间</p>
          <p>2023/03/12 斗虫中增加了高能榜数据。我真傻，真的。我之前单记着把高能榜数据算了出来，却忘了画图。</p>
          <p>2023/03/12 斗虫中的雷达图的统计项之一从场均弹幕改为了时均弹幕</p>
          <p>2023/03/03 多人斗虫中增加了更多表格</p>
          <p>2023/03/03 实现了多人斗虫日期范围选择</p>
          <p>2023/03/01 实现了多人斗虫beta版，欢迎报告bug</p>
          <p>2023/03/01 实现了solo斗虫beta版，欢迎报告bug</p>
          <p>2023/02/26 实现了独轮车界面，欢迎报告bug</p>
          <p>2023/02/25 实现了总览中每周分日观众统计</p>
          <p>2023/02/24 实现了总览中分析新观众&发言breakdown</p>
          <p>2023/02/21 实现了未结束直播实时更新数据，不再需要刷新页面</p>
          <p>2023/02/20 实现了总览页面</p>

          <p>妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭妈妈😭</p>
          <p>妈妈！！！！当你又回首一切————————！！这个世界————！！会好吗————？？！！————</p>
          <p>什么是我们？？？？？————————！！！！分开！！！！的借口！！！！————————</p>
          <p>带着她的影子！！！————！！——！——！站在街头！！——————！！————！——！！</p>
          <p>像恐惧的鱼——！——！——！！！！！！！拼命地游！！！！————————————————</p>
          <p>关于上海</p>
          <p>只是偶尔想起</p>
          <p> </p>
          <p>现在她的声音....</p>
          <p>只在回忆里............................</p>
          <p>你-——————————————————————————————</p>
          <p>还在改变我————————————————————————————————————————————</p>
          <p>你的歌声————————————————————————————————————————————————————————</p>
          <p>还在温暖我</p>
          <p>我时常在                                                                空旷的街上</p>
          <p>听着风声</p>
          <p>.</p>
          <p>.</p>
          <p>.</p>
          <p>想起你</p>
          <p>        ......你了忘想</p>
          <p>～～～～～声风着听</p>
          <p>里夜的样这</p>
          <p>在常时我</p>
          <p>关于上海</p>
          <p>我想的</p>
          <p>全<small>全</small></p>
          <p>是<small>是</small></p>
          <p>你<small>你</small></p>
          <p>想来生活无非是</p>
          <p><big>痛苦</big></p>
          <p>和</p>
          <p><small>美丽</small></p>
          <p>妈妈你是个<b>好姑娘</b></p>
          <p>你。要。保。护。好。你。自。己。</p>
          <p><b>妈妈</b>你是个好姑娘</p>
          <p>你要把持住你的<big>欲望</big></p>
          <p>你可知我想像你一样<span style="color: red;">纯洁</span></p>
          <p>你不能比我还要<span style="color: white;">放荡</span></p>
          <p>我————————</p>
          <p>只是<small>一个人</small></p>
          <p>我<span style="font-size: 16px;">的</span><span style="font-size: 14px;">码</span><span style="font-size: 12px;">里</span><span style="font-size: 10px;">全</span><span style="font-size: 8px;">都</span><span style="font-size: 6px;">是</span></p>
          <p><big>你</big></p>
          <p>妈妈————当你又回首一切————————！！这个世界————！！会好吗————？？！！————</p>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app-bar>
</template>

<script>

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
    },

    props: {
    },

  data: () => ({
      dialogActive: false,
    }),

    computed: {
      ...mapState(['drawer']),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
    },
  }
</script>

<style lang="sass">
.v-dialog
  height: 50%
  width: 75%
</style>